export class HttpError extends Error {
  public statusCode: number;
  public statusText: string;

  constructor(statusCode: number, statusText: string) {
    super(statusText);
    this.statusCode = statusCode;
    this.statusText = statusText;
  }
}
